import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDoubleHandsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={12}
    fill="none"
    viewBox="0 0 20 12"
    {...props}
  >
    <path d="M0 0h20v12.004H0z" />
    <path
      fill="#000"
      d="M13.584 0H10.9a1 1 0 0 0-.675.263L7.153 3.075c-.003.003-.006.01-.01.012a1.243 1.243 0 0 0-.065 1.75c.397.435 1.231.55 1.753.085q.006-.003.013-.006l2.497-2.288a.5.5 0 1 1 .675.737l-.816.748 4.55 3.693q.135.114.247.24V2L14.29.294A1 1 0 0 0 13.584 0M17 2.006v6.997c0 .553.447 1 1 1h2V2.006zm1.5 6.997a.5.5 0 0 1-.5-.5c0-.275.225-.5.5-.5s.5.225.5.5-.225.5-.5.5M0 10h2c.553 0 1-.447 1-1V2.006H0zm1.5-1.997c.275 0 .5.225.5.5s-.225.5-.5.5a.5.5 0 1 1 0-1m13.622.581-4.666-3.787-.937.86a2.253 2.253 0 0 1-3.178-.138 2.25 2.25 0 0 1 .137-3.178L9.034 0H6.416a1 1 0 0 0-.707.294L4 2v6.997h.572l2.828 2.56a2 2 0 0 0 2.813-.291l.006-.007.56.485a1.16 1.16 0 0 0 1.633-.169l.982-1.206.168.137a1 1 0 0 0 1.407-.147l.297-.365c.35-.431.284-1.06-.144-1.41"
    />
  </svg>
);
export default SvgDoubleHandsIcon;
